import React from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@mui/material';
import { Circle as BulletActive, ExpandMoreRounded as ExpandIcon, CreditScore as ApplicationLoan } from '@mui/icons-material';
import { useSelector } from 'react-redux';

const applicationItemsConfig = [
  {
    permission: 31,
    label: 'Application of Loan',
    to: '/application-loan',
    notificationKey: 'Application of Loan',
    notificationArrayProp: 'transactions',
    isLoadingProp: 'isTransactionsLoading',
    notificationValue: 'pending',
  },
];

const SidebarApplicationDropdown = ({ activeDropdown, user, transactions, shouldDisplayDotNotification, isTransactionsLoading, RouterLink, DisplayBubbleNotification }) => {
  const color = useSelector((state) => state.theme);
  const isActiveDropdown = Boolean(activeDropdown?.match(/application/gi));

  const allNotifications = {
    'Application of Loan': transactions,
  };

  const allLoadingStates = {
    isTransactionsLoading,
  };

  const hasNotifications = applicationItemsConfig.some(
    (item) => user.permissions.includes(item.permission) && item.notificationKey && shouldDisplayDotNotification(allNotifications[item.notificationKey], item.notificationKey),
  );

  return (
    <Accordion defaultExpanded={/approver/i.test(user.role)} elevation={0} square disableGutters>
      <AccordionSummary
        className={isActiveDropdown ? `FstoSidebarActiveDropdown-root ${color}` : `FstoSidebarDropdown-root ${color}`}
        expandIcon={<ExpandIcon htmlColor="white" />}
      >
        <ApplicationLoan />
        <Typography variant="sidebar">Application</Typography>
        {!isTransactionsLoading && hasNotifications ? <BulletActive className="FstoSidebarActiveNotif-root" /> : null}
      </AccordionSummary>

      <AccordionDetails className="FstoSidebarAccordionDetails-root">
        {applicationItemsConfig.map(
          (item) =>
            user.permissions.includes(item.permission) && (
              <RouterLink className="FstoSidebarLink-root" to={item.to} key={item.label}>
                {item.label}
                {!allLoadingStates[item.isLoadingProp] && item.notificationKey && (
                  <DisplayBubbleNotification notificationArray={allNotifications[item.notificationKey]} permission={item.notificationKey} value={item.notificationValue} />
                )}
              </RouterLink>
            ),
        )}
      </AccordionDetails>
    </Accordion>
  );
};

export default SidebarApplicationDropdown;
